/**
 * What the onboarding portfolio step's entries become.
 *
 * The step keeps what the user typed as plain strings (answers.tickers), and
 * their case says which kind each one is, by the rule the watchlist builder
 * reads typing with (classifyTickerEntry): a symbol is kept in capitals, so an
 * entry with a lower-case letter or a space is a word, kept as typed and
 * matched as a keyword. Nothing is looked up — "Apple" stays the word Apple
 * rather than being swapped for whatever ticker a tag lookup offers.
 *
 * Its own module, importing nothing, so the rules can be tested in node.
 */

/** A symbol as the step stores one: capitals, digits and punctuation, no spaces. */
export function isSymbolEntry(entry: string): boolean {
  const value = entry.trim();
  return value.length > 0 && !/\s/.test(value) && !/[a-z]/.test(value) && /[A-Z0-9]/.test(value);
}

/** The watchlist the entries make: symbols as tickers, the rest as keywords. */
export function ownPortfolioTerms(entries: string[]): {
  tickers: string[];
  keywords: string[];
} {
  const tickers: string[] = [];
  const keywords: string[] = [];
  for (const raw of entries) {
    const entry = raw.trim();
    if (!entry) continue;
    if (isSymbolEntry(entry)) {
      if (!tickers.includes(entry)) tickers.push(entry);
    } else if (!keywords.some((k) => k.toLowerCase() === entry.toLowerCase())) {
      keywords.push(entry);
    }
  }
  return { tickers, keywords };
}
